var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderError = function SvgOrderError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#orderError_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 72.993c1.744 1.754 3.439 3.578 5.261 5.254 1.182 1.092 1.201 1.814 0 2.964-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.271-49.994 6.493-72.889-8.317-3.798-2.456-7.092-5.713-10.629-8.57-1.114-.906-1.153-1.627-.077-2.67 3.73-3.657 7.392-7.38 11.045-11.115.97-.975 1.638-1.102 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.838 20.191 4.427 38.26-.087 53.986-13.668 2.732-2.36 2.693-2.399 5.222.126l4.418 4.446z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "orderError_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.612 103.616c-25.071 0-43.705-12.196-48.787-16.94l-59.524-50.185L60.61-9 159.5 31l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#orderError_svg__b)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 10.3,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 102.213 16.164)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m90.308 29.346.024-.39q.094-1.5.921-2.532.327-.405.702-.719t.894-.671a9 9 0 0 0 .856-.639q.301-.282.41-.613.067-.21.08-.42a1.33 1.33 0 0 0-.198-.794 1.75 1.75 0 0 0-.607-.517 1.8 1.8 0 0 0-.8-.245q-.849-.053-1.422.32-.538.373-.801 1.173l-.112.366-2.573-.836.111-.365q.552-1.722 1.792-2.55 1.26-.843 3.133-.726a5.5 5.5 0 0 1 1.837.417 3.8 3.8 0 0 1 1.392.992q.549.585.801 1.38.27.78.216 1.647-.045.743-.347 1.29a3.3 3.3 0 0 1-.678.916q-.379.367-1.012.86-.837.621-1.26 1.145-.405.507-.456 1.32l-.024.389zm1.277 4.25a1.62 1.62 0 0 1-1.153-.57q-.447-.507-.402-1.231a1.6 1.6 0 0 1 .55-1.137q.526-.465 1.215-.42.69.043 1.153.568.465.509.422 1.198a1.7 1.7 0 0 1-.552 1.172q-.526.463-1.233.42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M81.5 40h-53a7.62 7.62 0 0 1 7.619 7.619V97a7 7 0 0 0 7 7H81.5a7 7 0 0 0 7-7V47a7 7 0 0 0-7-7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CACED7",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M48.5 55h31M48.5 65h31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D9AE8",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M70.5 75h8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M87 104H50c5.08 0 5.443-9.333 4.99-14H94v7a7 7 0 0 1-7 7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#orderError_svg__c)",
    d: "M21.5 47.5a7.5 7.5 0 0 1 15 0V60h-15z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "orderError_svg__d",
    width: 59,
    height: 64,
    x: 30,
    y: 40,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M81.5 40h-51a7.365 7.365 0 0 1 7.365 7.365V97a7 7 0 0 0 7 7H81.5a7 7 0 0 0 7-7V47a7 7 0 0 0-7-7"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#orderError_svg__d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.028,
    cy: 50.058,
    fill: "#B9C2D1",
    opacity: 0.2,
    rx: 36.739,
    ry: 37.058,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.668,
    d: "M45.633 46.265a6.634 6.634 0 0 1-1.294-13.138 6.63 6.63 0 0 1 7.926 6.505v.266m17.475 6.367a6.634 6.634 0 0 1-4.69-11.323 6.63 6.63 0 0 1 10.686 1.855c.419.886.636 1.855.636 2.836v.265"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M46.6 89.999s-8.117-9.967-16.53-10.006c-8.414-.04-1.003 11.51 4.522 7.394S41.6 72.5 26.249 67"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "m86 82.148 13.168-9.127"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orderError_svg__c",
    x1: 29,
    x2: 29,
    y1: 40,
    y2: 100.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB8C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "orderError_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgOrderError;